import { render, staticRenderFns } from "./GruposClientesForm.vue?vue&type=template&id=c8d20e24&scoped=true"
import script from "./GruposClientesForm.vue?vue&type=script&lang=js"
export * from "./GruposClientesForm.vue?vue&type=script&lang=js"
import style0 from "./GruposClientesForm.vue?vue&type=style&index=0&id=c8d20e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d20e24",
  null
  
)

export default component.exports